import { Dispatch, ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";

import { ApplicationState } from "../store/ApplicationState";
import { GetHealthPlanMaster, GetRoles, GetUserList, UpdateUserStatus } from "../services/Users";
import { GetRoleDispatchTypes, HealthPlanDispatchTypes, UpdateUserStatusDispatchTypes, UserDispatchTypes } from "../models/DispatchTypes/User";
import {  GetRolesActionDispatchTypes, HealthPlanActionDispatchTypes, UpdateUserStatusActionDispatchTypes, UserActionDispatchTypes } from "../constants/User";
import { baseUrl } from "../constants/Config";
import { UserSearchPayload, UserStatusPayload } from "../models/User";

export const getUsers: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    UserDispatchTypes
  >
> = (payload: UserSearchPayload) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: UserActionDispatchTypes.GET_USERS_INVOKE,
    });

    const response = await GetUserList(baseUrl, payload);
    dispatch({
      response,
      type: UserActionDispatchTypes.GET_USERS_SUCCESS,
    });
  };
};

export const getRoles: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    GetRoleDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GetRolesActionDispatchTypes.GET_ROLES_INVOKE,
    });
    const response = await GetRoles(baseUrl);

    dispatch({
      response,
      type: GetRolesActionDispatchTypes.GET_ROLES_SUCCESS,
    });
  };
};

export const getHealthPlanMasterResp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    HealthPlanDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: HealthPlanActionDispatchTypes.HEALTH_PLAN_MASTER_INVOKE,
    });
    const response = await GetHealthPlanMaster(baseUrl);

    dispatch({
      response,
      type: HealthPlanActionDispatchTypes.HEALTH_PLAN_MASTER_SUCCESS,
    });
  };
};

export const updateUserStatus: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    UpdateUserStatusDispatchTypes
  >
> = (payload: UserStatusPayload) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: UpdateUserStatusActionDispatchTypes.UPDATE_USER_STATUS_INVOKE,
    });

    const response = await UpdateUserStatus(
      baseUrl,
      payload
    );

    dispatch({
            response: response,
            type: UpdateUserStatusActionDispatchTypes.UPDATE_USER_STATUS_SUCCESS,
          });
  };
};